<button
    (click)="clicked.emit($event)"
    [cdkMenuTriggerFor]="menu()"
    (cdkMenuOpened)="isMenuOpen.set(true)"
    (cdkMenuClosed)="isMenuOpen.set(false)"
    [pTooltip]="tooltip()"
    tooltipPosition="bottom"
    showDelay="500"
    hideDelay="200"
    type="button"
    class="duration-(--p-transition-duration) flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent transition-colors hover:bg-(--p-content-hover-background)"
    [ngClass]="active() || isMenuOpen() ? 'top-bar-button--active bg-white/12 dark:bg-(--p-content-hover-background)' : ''"
>
    <span class="material-symbols-outlined text-color text-2xl!">{{ icon() }}</span>
</button>
